import { render, staticRenderFns } from "./ModalKasKecilApproveEc.vue?vue&type=template&id=24e08750&"
import script from "./ModalKasKecilApproveEc.vue?vue&type=script&lang=js&"
export * from "./ModalKasKecilApproveEc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports